/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.discovery.studio.rpc.PlacementsRpc
 */
import * as References from './PlacementsRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.discovery.studio.rpc.PlacementsRpc#getPlacements
 */
export const GET_PLACEMENTS_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_discovery_studio_rpc_PlacementsRpc_getPlacements';
export const GET_PLACEMENTS_QUERY: RegisteredQuery<
  'result',
  References.GetPlacementsRequestType,
  References.GetPlacementsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_PLACEMENTS_QUERY_FIELD_NAME,
  args: ['page', 'published'],
  fetcher(
    request: References.GetPlacementsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetPlacementsResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getPlacementsRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});
